export enum Languages {
  RUSSIAN = 'ru',
  ENGLISH = 'en',
  TURKISH = 'tr',
}
